import { render, staticRenderFns } from "./BranchCreate.vue?vue&type=template&id=8f88078e&scoped=true"
import script from "./BranchCreate.vue?vue&type=script&lang=js"
export * from "./BranchCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f88078e",
  null
  
)

export default component.exports